import { update } from '@kundinos/nanostores';

import { modulesStore } from './stores';

import type { ModuleProductData } from '@Types/ModuleProduct';

const editModule = async (module: ModuleProductData): Promise<void> => {
  update(modulesStore, (prevModules) => {
    return prevModules.map((prevModule) => {
      return prevModule.id === module.id ? module : prevModule;
    });
  });
};

export default editModule;
